module.exports = __webpack_public_path__ + "static/media/ding.1b4a37a1.mp3";